<main id="main" class="main">
  <!-- Header -->
  <div class="row m-1">
    <div class="col-12 col-md-12 d-flex justify-content-between"
      style="background: #142a49 !important; font-size: 14px">
      <h6 class="title">
        Invoices &nbsp;&nbsp;
        <i class="bi bi-info-circle"></i>
      </h6>
    </div>
  </div>

  <!-- Filter -->
  <!-- <div class="form-group col-3">
                        <label>
                          Amount
                          <div class="currency-input">
                            <span>$</span>
                            <input type="text" placeholder="Amount" appTwodigits formControlName="invoiceAmount" [(ngModel)]="invoiceAmount"
                              aria-label="Amount" />
                          </div>
                        </label>
                      </div> -->
  <div class="row m-1">

    <!-- report type -->
    <!-- <div class="col-12 col-md-3">
      <div class="form-group">
        <label for="filterReportType">Report Type</label>
        <select
          id="filterReportType"
          class="form-control"
          placeholder="Select"
          [(ngModel)]="filterReportType"
          (change)="onReportTypeChange($event)"
        >
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of reportTypes" [value]="item.id">
            {{ item.reportType }}
          </option>
        </select>
      </div>
    </div> -->
    <!-- month / month range -->
    <div class="col-12 col-md-3">
      <div class="form-group">
        <div>
          <input type="radio" id="filterMonth" name="filterIsMonthRange" [value]="false"
            [(ngModel)]="filterIsMonthRange" (change)="onRangeChange()" />
          <label class="form-check-label ps-1 my-auto" for="filterMonth">
            Month
          </label>
          &nbsp;
          <input type="radio" id="filterRange" name="filterIsMonthRange" [value]="true" [(ngModel)]="filterIsMonthRange"
            (change)="onRangeChange()" />
          <label class="form-check-label ps-1 my-auto" for="filterRange">
            Range
          </label>
        </div>

        <!-- Note: Currently supports till July 1st 2024 only -->
        <input *ngIf="filterIsMonthRange; else elseMonthRange" type="text" class="form-control"
          placeholder="Select Month" bsDaterangepicker [(ngModel)]="filterDateSelection"
          [bsConfig]="{ rangeInputFormat: 'MMM YYYY', minMode: 'month',showWeekNumbers: false }"
          [maxDate]="maxDateForPicker" [minDate]="minDateForPicker" />
        <ng-template #elseMonthRange>
          <input type="text" class="form-control" placeholder="Select Month" [(ngModel)]="filterDateSelection"
            bsDatepicker [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month',showWeekNumbers: false }"
            [maxDate]="maxDateForPicker" [minDate]="minDateForPicker" />
        </ng-template>
      </div>
    </div>
    <!-- <div class="col-12 col-md-3" >
    <div class="filter-container">
      <form [formGroup]="filterForm">
        <div formArrayName="filters">
          <div
            *ngFor="let filter of filters.controls; let i = index"
            [formGroupName]="i"
            class="filter-row"
          >
            <select formControlName="type" class="form-control">
              <option *ngFor="let option of filterOptions" [value]="option.value">
                {{ option.label }}
              </option>
            </select>
            <input formControlName="value" type="text" class="form-control" />
            <button type="button" class="btn btn-danger" (click)="removeFilter(i)">
              X
            </button>
          </div>
        </div>

        <button type="button" class="btn btn-primary" (click)="addFilter()">+ Add Filter</button>
        <button type="button" class="btn btn-secondary" (click)="clearFilters()">Clear</button>
        <button type="submit" class="btn btn-info" (click)="search()">Search</button>
      </form>
    </div>
  </div> -->
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group dropdown-wrapper">
        <label for="filterReportType">Invoice Status</label>
        <!-- <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings3" [data]="InvoiceStatus"
              (onSelect)="onItemSelectInvoice($event)" (onSelectAll)="onSelectAllInvoice($event)"
              (onDeSelect)="onDeselectInvoice($event)" (onDeSelectAll)="onDeselectInvoiceAll()">
            </ng-multiselect-dropdown> -->
        <select id="filterReportType" name="status" class="form-control" placeholder="Select"
          [(ngModel)]="invoiceTypeValue" (change)="onInvoiceTypeChange($event)">
          <option value="" disabled selected>Select</option>
          <option *ngFor="let item of InvoiceStatus" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
        <i class="fa fa-remove clear-icon" title="Clear" *ngIf="invoiceTypeValue" (click)="clearInvoiceType()"></i>


      </div>
      <div *ngIf="invoiceTypeValue === 'OVERDUE'" class="submenu dropdown-wrapper">
        <label for="overdueOptions">Select Overdue Option:</label>
        <select id="overdueOptions" class="form-control" [(ngModel)]="specialInvoiceTypeValue">
          <option value="" disabled selected>Select Overdue Type</option>
          <option *ngFor="let item of specialFilters" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
        <!-- <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings3" [data]="specialFilters"
                          (onSelect)="onItemSelectSpecialInvoice($event)" (onSelectAll)="onSelectAllSpecialInvoice($event)"
                          (onDeSelect)="onDeselectSpecialInvoice($event)" (onDeSelectAll)="onDeselectSpecialInvoiceAll()">
                        </ng-multiselect-dropdown> -->

        <i class="fa fa-remove clear-icon" title="Clear" *ngIf="specialInvoiceTypeValue"
          (click)="clearOverdueInvoiceType()"></i>

      </div>
    </div>
    <div class="col-12 col-md-3 " *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Customer Name
        </label>
        <input id="filterReportType" class="form-control" placeholder="Customer Name" [(ngModel)]="customerName">
      </div>
    </div>
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Customer ID
        </label>
        <input id="filterReportType" class="form-control" placeholder="Customer ID" [(ngModel)]="customerid">
      </div>
    </div>
    <!-- Invoice Method -->


    <!-- Filter Method -->

    <!-- <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="filterReportType">Broker Type</label>
        <select id="filterReportType" class="form-control" placeholder="Select" [(ngModel)]="brokerTypeValue"
          (change)="getBrokers($event)">
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of brokerType" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div> -->
    <!-- Allies -->
    <!-- *ngIf="BrokersData && BrokersData.length>0" -->
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Brokers
        </label>
        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings" [data]="BrokersData"
          (onSelect)="onItemSelect($event)" (onSelectAll)="onSelectAll($event)" (onDeSelect)="onDeselectbroker($event)"
          (onDeSelectAll)="onDeselectbrokerAll()">
        </ng-multiselect-dropdown>
      </div>
    </div>

    <!-- Invoice Status -->


    <!-- <div class="col-12 col-md-3" *ngIf="invoiceTypeValue=='OVERDUE'">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Invoice Type
        </label>
        <select id="filterReportType" class="form-control" placeholder="Select" [(ngModel)]="specialInvoiceTypeValue"
          (change)="onInvoiceTypeChange($event)">
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of specialFilters" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
      </div>
    </div> -->
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group dropdown-wrapper">
        <label for="filterReportType">Customer Type</label>
        <select id="filterReportType" class="form-control" placeholder="Select" [(ngModel)]="customerTypeValue"
          (change)="getCustomerTypeDetails($event)">
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of customerType" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
        <!-- <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings3" [data]="customerType"
            (onSelect)="onItemSelectCustomerType($event)" (onSelectAll)="onSelectAllCustomerType($event)"
            (onDeSelect)="onDeselectCustomerType($event)" (onDeSelectAll)="onDeselectCustomerTypeAll()">
          </ng-multiselect-dropdown> -->
        <i class="fa fa-remove clear-icon" title="Clear" *ngIf="customerTypeValue" (click)="clearCustomerType()"></i>


      </div>
    </div>
    <div class="col-12 col-md-3" *ngIf="customerTypeRes && customerTypeRes.length>0 && filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Customers
        </label>
        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings2" [data]="customerTypeRes"
          (onSelect)="onItemSelectCustomer($event)" (onSelectAll)="onSelectAllCustomer($event)"
          (onDeSelect)="onDeselectbrokerCustomer($event)" (onDeSelectAll)="onDeselectbrokerAllCustomer()">
        </ng-multiselect-dropdown>
      </div>
    </div>


    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          IGBMS ID
        </label>
        <input id="filterReportType" class="form-control" placeholder="IGBMS ID" [(ngModel)]="fusbillCustomerId">


      </div>
    </div>
    <!-- <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Company Name
        </label>
        <input id="filterReportType" class="form-control" placeholder="Company Name" [(ngModel)]="fusbillCustomerId">


      </div>
    </div> -->
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group dropdown-wrapper">
        <label for="filterReportType">Payment Method</label>
        <select id="filterReportType" class="form-control" placeholder="Select" [(ngModel)]="paymentMethodValue"
          (change)="onPaymentTypeChange($event)">
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of invoiceMethods" [value]="item.value">
            {{ item.name }}
          </option>
        </select>
        <i class="fa fa-remove clear-icon" title="Clear" *ngIf="paymentMethodValue" (click)="clearPaymentType()"></i>

      </div>
    </div>
    <div class="col-12 col-md-3" *ngIf="filterDateSelection">
      <div class="form-group">
        <label for="multiSelectMembers" class="form-check-label">
          Province
        </label>
        <!-- <select id="filterReportType" class="form-control" placeholder="Select" [(ngModel)]="provinceTypeValue">
          <option value="" label="" disabled selected>Select</option>
          <option *ngFor="let item of provinces" [value]="item.value">
            {{ item.shortName }}
          </option>
        </select> -->
        <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings1" [data]="provinces"
          (onSelect)="onItemSelectProvince($event)" (onSelectAll)="onSelectAllProvince($event)"
          (onDeSelect)="onDeselectbrokerProvince($event)" (onDeSelectAll)="onDeselectbrokerAllProvince()">
        </ng-multiselect-dropdown>


      </div>
    </div>
  </div>


  <div class="row m-1">
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-3"></div>
    <div class="col-12 col-md-3" *ngIf="filterDateSelection" id="filterButtons">
      <button class="btn btn-primary" style="font-size: 12px" (click)="applyFilters()" title="Apply Filters">
        Apply filter
      </button>

      <button class="btn btn-secondary" style="font-size: 12px" (click)="resetFilters()" title="Reset Filters">
        Reset filter
      </button>
    </div>
    <!-- <div class="col-12 col-md-3">
      <button
        *ngIf="isShowGenerateReport()"
        class="btn btn-primary"
        style="font-size: 12px"
        (click)="clickGenerateReport()"
        title="Generate Report"
      >
        Generate Report
      </button>
    </div> -->
  </div>
  <br>
  <!-- <table>
    <tbody>
      <tr>
        <td><span class="fw-bold">Invoice Total:</span></td>
        <td><span
            class="text-primary">${{invoiceAmountDetails}}</span>
        </td>
        <td><span class="fw-bold">Amount Paid:</span></td>
        <td>
          <span class="text-success">${{invoiceAmountPaidDetails}}</span>
        </td>
        <div *ngIf="overDueAmount == 0">
        <td>
          <span class="fw-bold">OverDue:</span></td>
        <td >
          <span style="color:orange">$0</span>
        </td>
        </div>
        <div *ngIf="invoiceHSTTax>0">
  <td >
    <span class="fw-bold">HST:</span>
  </td>
  <td>
    <span style="color:orange">${{invoiceHSTTax}}</span>
  </td>
        </div>
        <div  *ngIf="invoicePSTTax>0" [ngStyle]="{'color': getTaxColor('PST')}">
          <td><span class="fw-bold">PST:</span></td>
          <td><span class="=">&nbsp;${{invoicePSTTax}},&nbsp;</span></td>
        </div>
        </tr>
        <tr>
        <div  *ngIf="invoiceGSTTax>0" [ngStyle]="{'color': getTaxColor('GST')}">
          <td><span class="fw-bold">GST:</span></td>
          <td><span class="">&nbsp;${{invoiceGSTTax}},&nbsp;</span></td>
        </div>
        <div  *ngIf="invoiceQSTTax>0" [ngStyle]="{'color': getTaxColor('QST')}">
        <td> <span class="fw-bold">QST:</span></td>
          <td><span class="">&nbsp;${{invoiceQSTTax}},&nbsp;</span></td>
        </div>
        <div  *ngIf="invoicePSTHealthTax>0" [ngStyle]="{'color': getTaxColor('PST_HEALTH_INSURANCE')}">
          <td><span class="fw-bold">PST on Health Insurance:</span></td>
          <td><span class="text-success">&nbsp;${{invoicePSTHealthTax}},&nbsp;</span></td>
        </div>
        <div  *ngIf="invoicePSTCriticalTax>0" [ngStyle]="{'color': getTaxColor('PST_CRITICAL_INSURANCE')}">
          <td> <span class="fw-bold">PST on Critical Illness:</span></td>
          <td><span class="text-success">&nbsp;${{invoicePSTCriticalTax}},&nbsp;</span></td>
        </div>
        </tr>
        <tr>
        <div  *ngIf="OverdueLTE_30 >0">
          <td><span class="fw-bold">OverDue(Below 30):</span></td>
          <td><span style="color:yellow">&nbsp;${{OverdueLTE_30}},&nbsp;</span></td>
        </div>
        <div  *ngIf="OverdueBTW_30_60 >0">
          <td><span class="fw-bold">OverDue(Between 30 to 60) :</span></td>
          <td><span style="color:orange">&nbsp;${{OverdueBTW_30_60}},&nbsp;</span></td>
        </div>
        <div  *ngIf="OverdueBTW_60_90 >0">
          <td><span class="fw-bold">OverDue(Between 60 to 90):</span></td>
          <td><span style="color:orangered">&nbsp;${{OverdueBTW_60_90}},&nbsp;</span></td>
        </div>
        <div  *ngIf="OverdueGT_90 >0">
          <td><span class="fw-bold">OverDue(above 90):</span></td>
          <td><span style="color:red">&nbsp;${{OverdueGT_90}},&nbsp;</span></td>
        </div>


      </tr>

    </tbody>
  </table> -->
  <!-- [ngStyle]="{'color': getTaxColor('QST')}" -->
  <div class="d-flex justify-content-between align-items-center p-3 bg-light border rounded"
    *ngIf="invoiceAmountDetails && filterDateSelection">


  <div class="left-content d-flex flex-column p-3" *ngIf="viewInVoices && filterDateSelection">

    <!-- Row for Total and Amount Paid -->
    <div class="d-flex p-2 border rounded m-2">
      <div class="d-flex w-auto mr-3">
        <span class="fw-bold">Total:</span>
        <span>&nbsp;${{ invoiceAmountDetails | numberFormat }};&nbsp;</span>
      </div>
      <div class="d-flex w-auto">
        <span class="fw-bold text-success">Amount Paid:</span>
        <span>&nbsp;${{ invoiceAmountPaidDetails | numberFormat }};&nbsp;</span>
      </div>
    </div>

    <!-- Row for Taxes -->
    <div class="d-flex p-2 border rounded m-2">
      <div class="d-flex w-auto mr-3" *ngIf="invoiceHSTTax > 0; else noinvoiceHSTTax">
        <span class="fw-bold">HST:</span>
        <span>&nbsp;${{ invoiceHSTTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoiceHSTTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">HST:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>

      <div class="d-flex w-auto mr-3" *ngIf="invoicePSTTax > 0; else noinvoicePSTTax">
        <span class="fw-bold">PST:</span>
        <span>&nbsp;${{ invoicePSTTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoicePSTTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">PST:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>

      <div class="d-flex w-auto mr-3" *ngIf="invoiceGSTTax > 0; else noinvoiceGSTTax">
        <span class="fw-bold">GST:</span>
        <span>&nbsp;${{ invoiceGSTTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoiceGSTTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">GST:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>

      <div class="d-flex w-auto mr-3" *ngIf="invoiceQSTTax > 0; else noinvoiceQSTTax">
        <span class="fw-bold">QST:</span>
        <span>&nbsp;${{ invoiceQSTTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoiceQSTTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">QST:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>

      <div class="d-flex w-auto mr-3" *ngIf="invoicePSTHealthTax > 0; else noinvoicePSTHealthTax">
        <span class="fw-bold">PST on Health Insurance:</span>
        <span>&nbsp;${{ invoicePSTHealthTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoicePSTHealthTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">PST on Health Insurance:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>

      <div class="d-flex w-auto mr-3" *ngIf="invoicePSTCriticalTax > 0; else noinvoicePSTCriticalTax">
        <span class="fw-bold">PST on Critical Illness:</span>
        <span>&nbsp;${{ invoicePSTCriticalTax | numberFormat }};&nbsp;</span>
      </div>
      <ng-template #noinvoicePSTCriticalTax>
        <div class="d-flex w-auto mr-3">
          <span class="fw-bold">PST on Critical Illness:</span>
          <span>&nbsp;$0.00;&nbsp;</span>
        </div>
      </ng-template>
    </div>

    <!-- Row for Overdue Amounts -->
    <div class="d-flex p-2 border rounded m-2">
      <div class="d-flex w-auto mr-3" *ngIf="OverdueLTE_30 > 0">
        <span class="fw-bold text-danger">Overdue (Below 30 Days):</span>
        <span>&nbsp;${{ OverdueLTE_30 | numberFormat }};&nbsp;</span>
      </div>

      <div class="d-flex w-auto mr-3" *ngIf="OverdueBTW_30_60 > 0">
        <span class="fw-bold text-danger">Overdue (30-60 Days):</span>
        <span>&nbsp;${{ OverdueBTW_30_60 | numberFormat }};&nbsp;</span>
      </div>

      <div class="d-flex w-auto mr-3" *ngIf="OverdueBTW_60_90 > 0">
        <span class="fw-bold text-danger">Overdue (60-90 Days):</span>
        <span>&nbsp;${{ OverdueBTW_60_90 | numberFormat }};&nbsp;</span>
      </div>

      <div class="d-flex w-auto mr-3" *ngIf="OverdueGT_90 > 0">
        <span class="fw-bold text-danger">Overdue (Above 90 Days):</span>
        <span>&nbsp;${{ OverdueGT_90 | numberFormat }};&nbsp;</span>
      </div>

      <div class="d-flex w-auto mr-3" *ngIf="overDueAmount == 0">
        <span class="fw-bold">Overdue:</span>
        <span>&nbsp;$0.00;&nbsp;</span>
      </div>
    </div>

  </div>



    <div class="right-content" style="display: inline-flex;gap:15px" *ngIf="viewInVoices && filterDateSelection">
      <!-- Export to Excel -->
      <div class="text-center">
        <i class="fa fa-file-excel-o" (click)="exportTableToExcel()" title="Download Excel"
          style="color: green; font-size: 24px; cursor: pointer;"></i>
        <p class="small text-success mt-1 mb-0">Excel</p>
      </div>

      <!-- Download All as ZIP -->
      <div class="text-center">
        <i class="fa fa-download" (click)="downloadAllAsZip()" title="Download All"
          [ngStyle]="{ 'pointer-events': isDisabled ? 'none' : 'auto', 'color': isDisabled ? 'gray' : 'blue' }"
          style="color: blue; font-size: 24px; cursor: pointer;"></i>
        <p class="small mt-1 mb-0" [ngStyle]="{  'color': isDisabled ? 'gray' : 'blue' }">Download</p>
      </div>

      <!-- Mail to All -->
      <div class="text-center">
        <i class="fa fa-envelope" title="Send Email" (click)="mailtocustomers()"
          style="color: black; font-size: 24px; cursor: pointer;"></i>
        <p class="small text-dark mt-1 mb-0">Mail</p>
      </div>
    </div>
  </div>


  <!-- Datatable -->


  <div class="row m-1 mt-4" *ngIf="viewInVoices && filterDateSelection">
    <!-- <div class="mb-3">

      <input type="text" class="form-control" placeholder="Search invoices"
        (input)="applySearch($event.target.value)" />
    </div> -->

    <div class="d-flex justify-content-between align-items-center">
      <div class="left-content d-flex">

      </div>
      <div class="right-content">
        <input type="text" class="form-control" [(ngModel)]="searchValue" (input)="onSearch($event.target.value)" placeholder="Search..." />

      </div>
    </div>
    <div class="table-responsive">
      <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" id="DataTables_Table_1"
        class="table text-nowrap">
        <thead>
          <tr>
            <th style="width: 30px">#</th>

            <th>IGBMS ID</th>
            <!-- <th>Type</th> -->
            <!-- <th>ID</th> -->
            <th>Name</th>
            <th>Invoice No</th>

            <th>Date</th>
            <th>Status</th>
            <th [hidden]="true">Amount</th>
            <th class="sorting text-center" (click)="sortInvoices('amount')" [ngClass]="{
                'sorting':true,
                'sorting_asc': isAmountAscending==true,
                'sorting_desc': isAmountAscending==false
                }">Amount
            </th>
            <!-- <th>Amount</th> -->
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let invoice of inVoiceList; let i = index">
            <td><span *ngIf="invoice.type=='IGBMS'"><img src="../../../assets/img/igbms_main.png" style="width:50%"
                  title="IGBMS">
              </span>
              <span *ngIf="invoice.type=='Staxbill-API'"><img src="../../../assets/img/staxbill_api.jpg"
                  style="width:50%" title="Staxbill-API">
              </span>
              <span *ngIf="invoice.type=='Staxbill'"><img src="../../../assets/img/staxbill_new.png" style="width:50%"
                  title="Staxbill">
              </span>

              <!-- <ng-template #staxbill><img src="../../../assets/img/staxbill.jpg" title="Staxbill" style="width:50%"></ng-template></td> -->
            <td>{{invoice.customer.fusebillCustomerId}}</td>
            <!-- <td>{{invoice.type}}</td> -->
            <!-- <td>{{invoice.id}}</td> -->
            <td>{{invoice.customer.firstName}}&nbsp;{{invoice.customer.lastName}}</td>
            <td>{{invoice.invoiceNumber}}</td>

            <td>{{invoice.invoiceDate | date}}</td>


            <td>
              <select id="filterReportType" class="form-control" placeholder="Select" [ngModel]="invoice.status"
                (change)="changeInvoiceStatus($event,invoice)">
                <option value="" label="" disabled selected>Select</option>
                <option *ngFor="let item of invoice.statusList" [value]="item">
                  {{ item.toLowerCase()=='post' ? 'Posted' : item | titlecase}}
                </option>
              </select>

            </td>
            <td [hidden]="true">${{invoice.invoiceAmount | number:'1.2-2'}}</td>
            <td style="text-align: right;padding-right: 20px;">${{invoice.invoiceAmount | number:'1.2-2'}}&nbsp;<i
                class="fa fa-info-circle" id="tooltip" style="cursor: pointer;">
                <table class="tooltiptext ignoreTable">
                  <tbody>
                    <tr class="ignoreTable">
                      <td>Amount Paid:<span *ngIf="invoice.amountPaid==0; else invoiceamount">$0.00</span><ng-template
                          #invoiceamount>${{invoice.amountPaid | number: '1.2-2'}}</ng-template></td>

                    </tr>
                    <div *ngIf="invoice.taxInformation?.overall_taxes">
                      <tr class="ignoreTable">
                        <td style="border-bottom: 1px dotted #fff"><b>Taxes</b></td>
                      </tr>
                      <tr class="ignoreTable" *ngFor="let item of objectKeys(invoice.taxInformation?.overall_taxes)">

                        <td>{{ item.key }}:<span *ngIf="item.value==0; else taxValue">$0.00</span><ng-template
                            #taxValue>${{item.value | number: '1.2-2'}}</ng-template></td>

                      </tr>
                    </div>
                  </tbody>
                </table>
              </i>
            </td>

            <td>
              <i class="fa fa-file-pdf-o" title="view" aria-hidden="true" data-bs-toggle="modal"
                style="cursor: pointer;color:red" (click)="viewInvoiceDetails(invoice)"></i>&nbsp;
              <i class="fa fa-edit" title="Edit" aria-hidden="true" style="cursor: pointer" data-bs-toggle="modal"
                [style.pointer-events]="invoice.status !== 'DRAFT' ? 'none' : 'auto'"
                [style.color]="invoice.status !== 'DRAFT' ? 'gray' : 'green'"
                (click)="editInvoiceDetails(invoice)"></i>&nbsp;
              <i class="fa fa-history" title="History" aria-hidden="true" data-bs-toggle="modal"
                style="cursor: pointer;color:blue" (click)="showInvoiceHistory(invoice)"></i>&nbsp;
              <!-- <i class="fa fa-trash-o" title="Delete" aria-hidden="true" data-bs-toggle="modal" style="cursor: pointer;color:red"
              (click)="deleteInvoiceDetails(invoice)"></i> -->
            </td>

          </tr>
        </tbody>
      </table>
    </div>
  </div>
</main>




<!-- View Confirmation Modal -->
<div class="modal fade" id="viewInvoice-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" style="overflow: hidden;">


        <div class="container">
          <table class="styled-table">
            <tbody>
              <tr>
                <!-- <td><span class="fw-bold">Name:&nbsp;
                  <span>
                      class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span></span>
                </td> -->
                <td>
                  <span style="display:flex;">
                    <span class="fw-bold">Name:&nbsp;</span>
                    <span  class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span>
                  </span>
                </td>

                <!-- <td><span class="fw-bold">Invoice Number:&nbsp;<span
                      class="text-primary">{{finalinvoiceres?.invoiceNumber}}</span></span></td> -->
                      


                      <!-- <td>
                  <span style="display:flex;">
                    <span class="fw-bold">Invoice Number:</span>
                    <span  class="text-primary">{{finalinvoiceres?.invoiceNumber}}</span>
                  </span>
                </td> -->
                <td>
  <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 4px;">
    <span class="fw-bold">Invoice Number:</span>
    <span class="text-primary">{{ finalinvoiceres?.invoiceNumber }}</span>
  </div>
</td>

  <!-- <td>
  <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 4px;">
    <span class="fw-bold">IGBMS ID:</span>
    <span class="text-primary">{{finalinvoiceres?.fusebillCustomerId}}</span>
  </div>
</td> -->
<td>
  <div style="display: grid; grid-template-columns: auto 1fr; column-gap: 4px;">
    <span class="fw-bold">IGBMS ID:</span>
    <div class="text-primary" style="word-break: break-word;">
       {{ finalinvoiceres?.fusebillCustomerId }}
    </div>
  </div>
</td>

<!-- 
                <td><span class="fw-bold" style="display:flex;">IGBMS ID:&nbsp;<span
                      class="text-primary">
                      {{finalinvoiceres?.fusebillCustomerId}}</span></span></td> -->


              </tr>
              <tr>
                <td><span class="fw-bold">Status:&nbsp;<span
                      class="text-primary">{{getInvoiceStatus(finalinvoiceres?.status)}}</span></span></td>
                <td>
                  <span class="fw-bold" style="margin-left:2px;">Month:&nbsp;<span class="text-primary">{{finalinvoiceres?.invoiceDate |
                      date:'MMM-yyyy'}}</span></span>
                </td>
              </tr>
              <!-- <tr>
            <td><span class="fw-bold">IGBMS ID:</span></td>
            <td><span class="text-primary">{{finalinvoiceres?.customerId}} / {{finalinvoiceres?.fusebillCustomerId}}</span></td>
            <td><span class="fw-bold">Status:</span></td>
            <td><span class="text-primary">{{finalinvoiceres?.status}}</span></td>

          </tr> -->
            </tbody>
          </table>

          <!-- Scrollable PDF Viewer Section -->
          <div class="scrollable">
            <pdf-viewer *ngIf="invoiceLink" id="pdf-viewer" [src]="invoiceLink" [render-text]="true"
              [original-size]="false" style="height: 90vh; width: 100%;"></pdf-viewer>
          </div>


        </div>


      </div>

      <div class="modal-footer">

        <div *ngFor="let button of actionButtons">
          <button type="button" class="btn btn-primary" id="closeaddadmin" *ngIf="button.condition"
            [style.backgroundColor]="button.backgroundColor" (click)="button.onClick()">
            <i [class]="button.icon" aria-hidden="true"></i>&nbsp;&nbsp; {{ button.label }}
          </button>
        </div>
        <button type="button" class="btn btn-primary" (click)="DownloadInvoice(invoiceLink)">
          <i class="fa fa-download" aria-hidden="true"></i>&nbsp;&nbsp;Download
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="refundInvoiceDetails-modal" tabindex="-1">
  <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">View</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" style="overflow: hidden;">
        <div class="container">
          <div class="row">
            <table class="styled-table">
              <tbody>
                <tr>
                  <td><span class="fw-bold">Name:&nbsp;<span
                        class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span></span>
                  </td>

                  <td><span class="fw-bold">Invoice Number:&nbsp;<span
                        class="text-primary">{{finalinvoiceres?.invoiceNumber}}</span></span></td>

                  <td><span class="fw-bold">Customer ID&nbsp;/&nbsp;IGBMS ID:&nbsp;<span
                        class="text-primary">{{finalinvoiceres?.customerId}} /
                        {{finalinvoiceres?.fusebillCustomerId}}</span></span>
                  </td>
                  <td>
                    <span class="fw-bold">Status:&nbsp;<span
                        class="text-primary">{{getInvoiceStatus(finalinvoiceres?.status)}}</span></span>
                  </td>


                </tr>
                <tr>
                  <td>
                    <span class="fw-bold">Month:&nbsp;<span class="text-primary">{{finalinvoiceres?.invoiceDate |
                        date:'MMM-yyyy'}}</span></span>
                  </td>
                  <td>
                    <span class="fw-bold">Amount Paid:&nbsp;<span class="text-primary">&nbsp;<span
                          *ngIf="specificInvoiceAmountPaid;else noamountpaid">${{specificInvoiceAmountPaid}}</span><ng-template
                          #noamountpaid><span>$0</span></ng-template></span></span>
                  </td>
                  <td><span class="fw-bold">Payment Method:&nbsp;<span
                        class="text-primary">{{getpaymentName(finalinvoiceres?.paymentMethod)}}</span></span></td>
                </tr>

                <!-- <tr>
                        <td><span class="fw-bold">IGBMS ID:</span></td>
                        <td><span class="text-primary">{{finalinvoiceres?.customerId}} / {{finalinvoiceres?.fusebillCustomerId}}</span></td>
                        <td><span class="fw-bold">Status:</span></td>
                        <td><span class="text-primary">{{finalinvoiceres?.status}}</span></td>

                      </tr> -->
              </tbody>
            </table>
          </div>
          <div class="row">
            <!-- First Column -->
            <div class="col-md-5">
              <div class="scrollable mt-3">
                <pdf-viewer *ngIf="invoiceLink" id="pdf-viewer" [src]="invoiceLink" [render-text]="true"
                  [original-size]="false" style="height: 90vh; width: 100%;"></pdf-viewer>
              </div>
            </div>

            <!-- Second Column -->
            <div class="col-md-7">

              <div class="modal-body" style="height: 450px">

                <form [formGroup]="refundInvoiceForm"
                  *ngIf="finalinvoiceres.customerType !='Corporate';else showCorporate">
                  <div class="container">
                    <div class="row">
                      <div class="form-group col-12">

                        <div *ngIf="refundCreditDetails?.creditInformation.length>0">

                          <label class="form-check-label ps-1 my-auto" for="filterMonth">
                            Credit History
                          </label>

                          <table class="table table-bordered table-striped table-hover">
                            <thead class="table-dark">
                              <tr>
                                <th> Number</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Note</th>
                              </tr>
                            </thead>
                            <tbody *ngFor="let item of refundCreditDetails.creditInformation">
                              <tr>
                                <td>{{ item.invoiceNumber }}</td>
                                <td>${{ item.creditAmount | number: '1.2-2' }}</td>
                                <td>{{ item.status }}</td>
                                <td>{{ item.created | date }}</td>
                                <td>{{ item.reference }}</td>
                              </tr>
                            </tbody>
                          </table>

                        </div>
                        <div *ngIf="refundCreditDetails?.refundInformation.length>0">


                          <label class="form-check-label ps-1 my-auto" for="filterMonth">
                            Refund History
                          </label>

                          <table class="table table-bordered table-striped table-hover">

                            <thead class="table-dark">
                              <tr>
                                <th> Number</th>
                                <th>Amount</th>
                                <th>Status</th>
                                <th>Date</th>
                                <th>Note</th>
                              </tr>
                            </thead>
                            <tbody *ngFor="let item of refundCreditDetails.refundInformation">
                              <tr>
                                <td>{{item.invoiceNumber}}</td>
                                <td>${{item.refundAmount | number:'1.2-2'}}</td>
                                <td>{{item.status}}</td>
                                <td>{{item.created | date}}</td>
                                <td>{{item.reference}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>

                        <br>
                        <div>

                          <label class="form-check-label ps-1 my-auto" for="filterMonth">
                            Plans
                          </label>
                          <table class="table table-bordered table-striped table-hover">
                            <thead class="table-dark">
                              <tr>
                                <th>Plan</th>
                                <th>Coverage</th>
                                <th>Amount</th>
                                <th *ngIf="finalinvoiceres.planInformation">Tax</th>
                                <th>Type</th>
                                <th>Refund</th>
                              </tr>
                            </thead>

                            <tbody *ngIf="finalinvoiceres?.planInformation">
                              <tr *ngFor="let item of finalinvoiceres.planInformation; let i = index"
                                [formGroupName]="i">
                                <td style="width:25%">
                                  <input type="checkbox" (change)="onCheckboxChange(item, i, $event)"
                                    formControlName="checkbox" [checked]="item.selected" />
                                  <span>&nbsp;{{ item.planName }}</span>
                                </td>
                                <td>{{ item?.coverage1 }}</td>
                                <td style="text-align:end" style="width:13%">${{ (item?.amount ?? item?.price) | number:
                                  '1.2-2' }}</td>
                                <td style="text-align:end" style="width:13%">
                                  <!-- Tax Details -->
                                  ${{checktaxValue(item) | number: '1.2-2' }}
                                  <i class="fa fa-info-circle" id="tooltip" style="cursor: pointer;">
                                    <table class="tooltiptext ignoreTable">
                                      <tbody>
                                        <tr class="ignoreTable">
                                          <td>Tax:{{item?.taxStatement}}</td>

                                        </tr>
                                        <!-- <tr class="ignoreTable">
                                                              <td>Reason:{{client?.terminationReason}}</td>

                                                            </tr> -->

                                      </tbody>
                                    </table>
                                  </i>
                                </td>
                                <td>
                                  <div>
                                    <label>
                                      <input type="radio" value="FULL" formControlName="refundType"
                                        [attr.disabled]="isCheckboxDisabledTotal(item) ? null : true"
                                        (change)="onRefundinvoiceChange(item, $event,i)" />
                                      Total
                                    </label>
                                    <label>
                                      <input type="radio" value="PARTIAL" formControlName="refundType"
                                        [attr.disabled]="isCheckboxDisabledPartial(item) ? null : true"
                                        (change)="onRefundinvoiceChange(item, $event,i)" />
                                      Partial
                                    </label>
                                  </div>
                                </td>
                                <td>
                                  <div class="form-group">
                                    <label for="refundAmount-{{ i }}" class="form-label">Amount</label>
                                    <span style="margin-top:-4px;font-size: 14px;">$</span>
                                    <input id="refundAmount-{{ i }}" type="text" class="form-control"
                                      (input)="updateRefundAmount(item, $event, i)"
                                      [attr.disabled]="isCheckboxDisabled(item) ? null : true"
                                      formControlName="refundAmount" placeholder="Amount" [disabled]="!item.selected" />
                                  </div>

                                  <div class="form-group">
                                    <label for="tax-{{ i }}" class="form-label">Tax</label>
                                    <span style="margin-top:-4px;font-size: 14px;">$</span>
                                    <input id="tax-{{ i }}" type="text" class="form-control" readonly
                                      formControlName="tax" placeholder="Tax"
                                      [attr.disabled]="isCheckboxDisabled(item) ? null : true"
                                      [disabled]="!item.selected" />
                                  </div>

                                  <div class="form-group">
                                    <label for="refundAmountTotal-{{ i }}" class="form-label">Total</label>
                                    <span style="margin-top:-4px;font-size: 14px;">$</span>
                                    <input id="refundAmountTotal-{{ i }}" type="text" class="form-control" readonly
                                      formControlName="refundAmountTotal" placeholder="Total" />
                                  </div>
                                </td>

                                <!-- <td>

                                <input type="text" class="form-control" (input)="updateRefundAmount(item, $event,i)" formControlName="refundAmount" placeholder="Amount" [disabled]="!item.selected" />
                                <input type="text" class="form-control"  formControlName="tax" placeholder="Tax" [disabled]="!item.selected" />
                                <input type="text" class="form-control" formControlName="refundAmountTotal" placeholder="Total" />
                                </td> -->
                              </tr>

                            </tbody>
                          </table>


                        </div>

                      </div>
                    </div>
                  </div>
                </form>

                <ng-template #showCorporate>
                  <form [formGroup]="refundInvoiceForm">
                    <div class="container">
                      <div class="row">
                        <div class="form-group col-12">

                          <div *ngIf="refundCreditDetails?.creditInformation.length>0">

                            <label class="form-check-label ps-1 my-auto" for="filterMonth">
                              Credit History
                            </label>

                            <table class="table table-bordered table-striped table-hover">
                              <thead class="table-dark">
                                <tr>
                                  <th> Number</th>
                                  <th>Amount</th>
                                  <th>Status</th>
                                  <th>Date</th>
                                  <th>Note</th>
                                </tr>
                              </thead>
                              <tbody *ngFor="let item of refundCreditDetails.creditInformation">
                                <tr>
                                  <td>{{ item.invoiceNumber }}</td>
                                  <td>${{ item.creditAmount | number: '1.2-2' }}</td>
                                  <td>{{ item.status }}</td>
                                  <td>{{ item.created | date }}</td>
                                  <td>{{ item.reference }}</td>
                                </tr>
                              </tbody>
                            </table>

                          </div>
                          <div *ngIf="refundCreditDetails?.refundInformation.length>0">


                            <label class="form-check-label ps-1 my-auto" for="filterMonth">
                              Refund History
                            </label>

                            <table class="table table-bordered table-striped table-hover">

                              <thead class="table-dark">
                                <tr>
                                  <th> Number</th>
                                  <th>Amount</th>
                                  <th>Status</th>
                                  <th>Date</th>
                                  <th>Note</th>
                                </tr>
                              </thead>
                              <tbody *ngFor="let item of refundCreditDetails.refundInformation">
                                <tr>
                                  <td>{{item.invoiceNumber}}</td>
                                  <td>${{item.refundAmount | number:'1.2-2'}}</td>
                                  <td>{{item.status}}</td>
                                  <td>{{item.created | date}}</td>
                                  <td>{{item.reference}}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <br>
                          <div>
                            <label class="form-check-label ps-1 my-auto" for="filterMonth">
                              Plans
                            </label>
                            <table class="table table-bordered table-striped table-hover">
                              <thead class="table-dark">
                                <tr>
                                  <th>Plan Name</th>
                                  <th>Amount</th>
                                  <th>Tax</th>
                                  <th>Type</th>
                                  <th>Refund</th>
                                </tr>
                              </thead>
                              <tbody *ngIf="finalCorpValue && finalCorpValue.length>0">
                                <!-- Loop through all the plans -->
                                <!-- <ng-container *ngFor="let plan of finalCorpValue;let j =index"> -->
                                  <!-- Check if there are subscriptions -->
                                  <!-- <ng-container *ngIf="plan.details.plans.subscriptions?.length > 0"> -->
                                  <!-- Display plan owner's name as a row -->
                                  <!-- <tr>
                                    <td colspan="5">
                                      <strong>{{ plan.firstName }} {{ plan.lastName }}</strong>
                                    </td>
                                  </tr> -->
                                  <!-- Loop through each subscription -->
                                  <!-- plan.plans.subscriptions -->
                                  <tr *ngFor="let item of finalCorpValue; let i = index" [formGroupName]="i">
                                    <td>
                                      <div class="row">
                                      <span>
                                        <strong>{{ item.firstName }} {{ item.lastName }}</strong>
                                      </span>
                                    </div>

                                      <br>
                                      <input type="checkbox" (change)="onCheckboxChange1(item, i, $event)"
                                        [checked]="item.selected" />

                                      <span>&nbsp;{{ item.planName }}-{{ item.coverage1 }}</span>

                                    </td>
                                    <td style="text-align:end" style="width:13%">
                                      ${{ (item?.amount ?? item?.price) | number: '1.2-2' }}
                                    </td>
                                    <td style="text-align: end;" style="width:13%">
                                      <span *ngIf="checktaxValue(item); else notaxValue">
                                        ${{ checktaxValue(item) | number: '1.2-2' }}
                                              <i class="fa fa-info-circle" id="tooltip" style="cursor: pointer;">
                                                <table class="tooltiptext ignoreTable">
                                                  <tbody>
                                                    <tr class="ignoreTable">
                                                      <td>Tax:{{item?.taxStatement}}</td>

                                                    </tr>


                                                  </tbody>
                                                </table>
                                              </i>
                                      </span>
                                      <ng-template #notaxValue>
                                        <span>---</span>
                                      </ng-template>
                                    </td>
                                    <td>
                                      <div>
                                        <label>
                                          <input type="radio" value="FULL" formControlName="refundType"
                                            [attr.disabled]="isCheckboxDisabledTotal(item) ? null : true"
                                            (change)="onRefundinvoiceChange1(item, $event,i,j)" />
                                          Total
                                        </label>
                                        <label>
                                          <input type="radio" value="PARTIAL" formControlName="refundType"
                                            [attr.disabled]="isCheckboxDisabledPartial(item) ? null : true"
                                            (change)="onRefundinvoiceChange1(item, $event,i,j)" />
                                          Partial
                                        </label>
                                      </div>
                                    </td>
                                    <td>
                                      <div class="form-group">
                                        <label for="refundAmount-{{ i }}" class="form-label">Amount</label>
                                        <span style="margin-top:-4px;font-size: 14px;">$</span>
                                        <input id="refundAmount-{{ i }}" type="text" class="form-control"
                                          (input)="updateRefundAmount(item, $event, i)"
                                          [attr.disabled]="isCheckboxDisabled(item) ? null : true"
                                          formControlName="refundAmount" placeholder="Amount"
                                          [disabled]="!item.selected" />
                                      </div>

                                      <div class="form-group">
                                        <label for="tax-{{ i }}" class="form-label">Tax</label>
                                        <span style="margin-top:-4px;font-size: 14px;">$</span>
                                        <input id="tax-{{ i }}" type="text" class="form-control" readonly
                                          formControlName="tax" placeholder="Tax"
                                          [attr.disabled]="isCheckboxDisabled(item) ? null : true"
                                          [disabled]="!item.selected" />
                                      </div>

                                      <div class="form-group">
                                        <label for="refundAmountTotal-{{ i }}" class="form-label">Total</label>
                                        <span style="margin-top:-4px;font-size: 14px;">$</span>
                                        <input id="refundAmountTotal-{{ i }}" type="text" class="form-control" readonly
                                          formControlName="refundAmountTotal" placeholder="Total" />
                                      </div>
                                    </td>
                                  </tr>
                                <!-- </ng-container> -->
                                <!-- </ng-container> -->
                              </tbody>
                            </table>
                          </div>


                        </div>
                      </div>
                    </div>
                  </form>
                </ng-template>
                <form [formGroup]="refundInvoiceFormPayment">
                  <div class="container">
                    <div class="row">

                      <div class="form-group col-8">
                        <label for="status">Refund Method<span style="color: red">*</span></label>
                        <!-- <select id="filterReportType" class="form-control" formControlName="paymentMethod" placeholder="Select" [(ngModel)]="finalinvoiceres.paymentMethod"
                            (change)="onPaymentTypeChange($event)">
                            <option value="" label="" disabled selected>Select</option>
                            <option *ngFor="let item of refundPaymentMethods" [value]="item.value">
                              {{ item.name }}
                            </option>
                          </select> -->
                        <div class="radio-group">
                          <!-- <label *ngFor="let option of refundPaymentMethods" class="radio-option">
                              <input type="radio" [value]="option.value" formControlName="paymentMethod" [(ngModel)]="finalinvoiceres.paymentMethod" name="radioGroup" />
                              &nbsp;{{ option.name }}
                            </label> -->
                          <label *ngFor="let option of refundPaymentMethods1" class="radio-option">
                            <input type="radio" [value]="option.value" formControlName="paymentMethod" name="radioGroup"
                              (change)="paymentcheck($event)" />
                            &nbsp;{{ option.name }}
                          </label>
                          <div class="row" *ngIf="otherpaymentMethodValue">

                            <div class="form-group col-4 input-wrapper1">
                              <label>Payment Name:<span class="text-danger">*</span></label>

                              <select id="filterReportType" class="form-control" formControlName="OtherpaymentMethod"
                                placeholder="Select">
                                <option value="" label="" disabled selected>Select</option>
                                <option *ngFor="let item of refundMethods" [value]="item.value">
                                  {{ item.name }}
                                </option>
                              </select>
                              <!-- <input type="text" class="form-control" formControlName="OtherpaymentMethod"
                                placeholder="Enter payment method"> -->
                              <!-- <div *ngIf="editinvoice['paymentMethod'].touched && editinvoice['paymentMethod'].invalid"
                                              class="help-block text-danger">
                                              <div *ngIf="editinvoice['paymentMethod'].errors && editinvoice['paymentMethod'].errors['required']">
                                                Select the payment method</div>
                                            </div> -->
                            </div>
                          </div>

                        </div>
                        <!-- <div *ngIf="editinvoice['paymentMethod'].touched && editinvoice['paymentMethod'].invalid"
                            class="help-block text-danger">
                            <div *ngIf="editinvoice['paymentMethod'].errors && editinvoice['paymentMethod'].errors['required']">
                              Select the payment method</div>
                          </div> -->
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12">
                        <label for="filterReportType">Reference<span class="text-danger">*</span></label>
                        <textarea type="text" appCapitalize class="form-control" placeholder="Enter Reason"
                          formControlName="reason"></textarea>
                      </div>
                    </div>
                  </div>
                </form>
              </div>

              <!-- [disabled]="(refundInvoiceFormPayment.invalid || refundInvoiceForm.invalid)" -->
              <div class="modal-footer">
                <button type="button" class="btn btn-primary" (click)="refundinvoiceAmount()"
                  [disabled]="(refundInvoiceFormPayment.invalid || refundInvoiceForm.invalid)">
                  Refund
                </button>
              </div>
            </div>

          </div>
        </div>

        <!-- Scrollable PDF Viewer Section -->

      </div>
    </div>



  </div>
</div>

<!-- Edit Confirmation Modal -->
<div class="modal fade" data-bs-backdrop="static" id="editInvoice-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Edit Invoice</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">
        <table>
          <tbody>
            <tr>
              <td><span class="fw-bold">Name:&nbsp;<span
                    class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span></span>
              </td>

              <td><span class="fw-bold">Invoice Number:&nbsp;<span
                    class="text-primary">{{finalinvoiceres?.invoiceNumber}}</span></span></td>

              <td><span class="fw-bold">Customer ID&nbsp;/&nbsp;IGBMS ID:&nbsp;<span
                    class="text-primary">{{finalinvoiceres?.customerId}} /
                    {{finalinvoiceres?.fusebillCustomerId}}</span></span></td>


            </tr>
            <tr>
              <td><span class="fw-bold">Status:&nbsp;<span
                    class="text-primary">{{getInvoiceStatus(finalinvoiceres?.status)}}</span></span></td>

            </tr>

          </tbody>
        </table>
        <div class="container">
          <!-- Scrollable PDF Viewer Section -->
          <!-- <div class="row m-1">
            <div class="col-12 col-md-3"></div>
            <div class="col-12 col-md-3"></div>
            <div class="col-12 col-md-3"></div>
            <div class="col-12 col-md-3" id="filterButtons">
              <label for="filterReportType">Actions:</label>
              <select id="filterReportType" class="form-control" placeholder="Select"
                (change)="invoiceActionsStatus($event)">
                <option value="" label="" disabled selected>Select</option>
                <option value="delete" label="" *ngIf="deleteInvoice">Delete</option>
                <option value="cancel" label="" *ngIf="cancelInvoice">Cancel</option>
                <option value="refund" label="" *ngIf="refundInvoice">Refund</option>
                <option value="regenerate" label="" *ngIf="regenerateInvoice">Re-Generate</option>
              </select>
              <i class="fa fa-file-pdf-o" title="view" aria-hidden="true" data-bs-toggle="modal"
                style="cursor: pointer;color:red" (click)="viewInvoiceDetailspdf()"></i>
            </div>

          </div> -->

          <!-- Static Section -->
          <div class="static row">
            <!-- Due Date Field -->

            <!-- <div class="form-group col-4">
              <label for="dueDate">Invoice Number</label>
              <input type="text" id="amountPaid" [readonly]="true" [(ngModel)]="invoiceNumber" class="form-control"
                placeholder="Invoice Number" />
            </div>
            <div class="form-group col-4">
              <label for="dueDate">Customer ID</label>
              <input type="text" id="amountPaid" [readonly]="true" [(ngModel)]="customerId" class="form-control"
                placeholder="Customer ID" />
            </div>
            <div class="form-group col-4">
              <label for="dueDate">FusbillCustomer ID</label>
              <input type="text" id="amountPaid" [readonly]="true" [(ngModel)]="fusbillCustomerIdDetails"
                class="form-control" placeholder="FusbillCustomer ID" />
            </div> -->

            <form [formGroup]="editInvoiceForm">
              <div class="row">
                <div class="form-group col-3">
                  <label for="dueDate">Invoice Date<span style="color: red">*</span></label>
                  <input type="text" id="dueDate" [readonly]="true" formControlName="invoiceDate"
                    [(ngModel)]="invoiceDate" class="form-control" placeholder="Select Date" bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: false }"
                    [maxDate]="maxDateForPicker" />
                  <div *ngIf="editinvoice['invoiceDate'].touched && editinvoice['invoiceDate'].invalid"
                    class="help-block text-danger">
                    <div *ngIf="editinvoice['invoiceDate'].errors && editinvoice['invoiceDate'].errors['required']">
                      Please select invoice date</div>
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="dueDate">Due Date<span style="color: red">*</span></label>
                  <input type="text" id="dueDate" [readonly]="true" formControlName="dueDate" [(ngModel)]="dueDate"
                    class="form-control" placeholder="Select Date" bsDatepicker
                    [bsConfig]="{ dateInputFormat: 'YYYY-MM-DD', showWeekNumbers: false }"
                    [maxDate]="maxDateForPicker" />
                  <div *ngIf="editinvoice['dueDate'].touched && editinvoice['dueDate'].invalid"
                    class="help-block text-danger">
                    <div *ngIf="editinvoice['dueDate'].errors && editinvoice['dueDate'].errors['required']">
                      Please select due date</div>
                  </div>
                </div>

                <!-- Amount Paid Field -->


                <!-- <div class="form-group col-3">
                    <label>
                      Amount</label>
                      <div class="currency-input">
                        <span>$</span>
                        <input type="text" placeholder="Amount" appTwodigits formControlName="invoiceAmount" [(ngModel)]="invoiceAmount"
                          aria-label="Amount" />
                      </div>

                  </div> -->
                <div class="form-group col-3">
                  <label for="status">Status<span style="color: red">*</span></label>
                  <select id="filterReportType" formControlName="invoicestatus" class="form-control"
                    [(ngModel)]="invoiceStatus" (change)="onInvoiceTypeChange($event)">
                    <option value="" disabled selected>Select</option>
                    <option *ngFor="let item of finalinvoiceres.statusList" [value]="item">
                      {{ item }}
                    </option>
                  </select>
                  <div *ngIf="editinvoice['invoicestatus'].touched && editinvoice['invoicestatus'].invalid"
                    class="help-block text-danger">
                    <div *ngIf="editinvoice['invoicestatus'].errors && editinvoice['invoicestatus'].errors['required']">
                      Please select invoice status</div>
                  </div>
                </div>
                <div class="form-group col-3">
                  <label for="amountPaid">Amount to be Paid<span style="color: red">*</span></label>
                  <div class="input-group input-wrapper1">

                    <span style="margin-top:4px;font-size: 14px;">$</span>
                    <input type="text" id="amountPaid" formControlName="invoiceAmount" [(ngModel)]="invoiceAmount"
                      class="form-control" placeholder="Enter amount" appTwodigits />

                    <div *ngIf="editinvoice['invoiceAmount'].touched && editinvoice['invoiceAmount'].invalid"
                      class="help-block text-danger">
                      <div
                        *ngIf="editinvoice['invoiceAmount'].errors && editinvoice['invoiceAmount'].errors['required']">
                        Please enter invoice amount</div>
                    </div>
                  </div>
                </div>



              </div>
              <div class="row">

              </div>
              <div class="row">

                <div class="form-group col-8">
                  <label for="status">Reference<span style="color: red">*</span></label>
                  <textarea formControlName="reason" appCapitalize class="form-control" rows="3"
                    placeholder="Reference"></textarea>
                  <div *ngIf="editinvoice['reason'].touched && editinvoice['reason'].invalid"
                    class="help-block text-danger">
                    <div *ngIf="editinvoice['reason'].errors && editinvoice['reason'].errors['required']">
                      Please enter the reference</div>
                  </div>
                </div>
              </div>

            </form>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="resetPayment()">
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="submiteditInvoice()"
          [disabled]="editInvoiceForm.invalid">
          Save
        </button>
      </div>
    </div>
  </div>
</div>

<!-- History Confirmation Modal -->
<div class="modal fade" data-bs-backdrop="static" id="historyInvoice-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">History</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">

        <div class="container">
          <table>
            <tbody>
              <tr>
                <td><span class="fw-bold">Name:&nbsp;<span
                      class="text-primary">{{finalinvoiceres?.customer?.firstName}}&nbsp;&nbsp;{{finalinvoiceres?.customer?.lastName}}</span></span>
                </td>

                <td><span class="fw-bold">Invoice Number:&nbsp;<span
                      class="text-primary">{{finalinvoiceres?.invoiceNumber}}</span></span></td>

                <td><span class="fw-bold">Customer ID&nbsp;/&nbsp;IGBMS ID:&nbsp;<span
                      class="text-primary">{{finalinvoiceres?.customerId}} /
                      {{finalinvoiceres?.fusebillCustomerId}}</span></span></td>


              </tr>
              <tr>
                <td><span class="fw-bold">Status:&nbsp;<span
                      class="text-primary">{{getInvoiceStatus(finalinvoiceres?.status)}}</span></span></td>

              </tr>

            </tbody>
          </table>
          <br>
          <div class="table-responsive">
            <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1" id="DataTables_Table_2"
              class="table text-nowrap" *ngIf="historyDetails.length>1">
              <thead>
                <tr>
                  <th style="width: 30px">#</th>
                  <th>Date</th>
                  <th>Modified By</th>
                  <th>Note</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let invoice of historyDetails; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{invoice.created | date}}</td>
                  <td>{{capitalize(invoice.changedByUsername)}}</td>
                  <td>{{invoice.reason}}</td>
                </tr>

              </tbody>
            </table>
          </div>
          <div class="table-responsive" *ngIf="historyDetails.length==1">
            <table>
              <thead>
                <tr>
                  <th style="width: 30px">#</th>

                  <th>Date</th>
                  <th>Modified By</th>
                  <th>Note</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let invoice of historyDetails; let i = index">
                  <td>{{i+1}}</td>
                  <td>{{invoice.created | date}}</td>
                  <td>{{invoice.changedByUsername}}</td>
                  <td>{{invoice.reason}}</td>

                </tr>

              </tbody>
            </table>
          </div>
          <div style="text-align: center;margin-top: 10px" *ngIf="historyDetails.length==0">
            <span>No Details found</span>

          </div>

        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel
          (click)="resetPayment()">
          Close
        </button>

      </div>
    </div>
  </div>
</div>
<!-- New Regenerate Confirmation Modal -->
<div class="modal fade" data-bs-backdrop="static" id="generateInvoice-modal" tabindex="-1">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Generate Invoice</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body" style="height:40vh">

        <form [formGroup]="generateInvoiceform">
          <div class="container">
            <div class="input-wrapper row">

              <div class="form-group col-3">
                <label for="filterReportType">Invoice Month<span style="color: red">*</span></label>

                <input type="text" formControlName="invoiceMonth" class="form-control" placeholder="Select Month"
                  bsDatepicker [bsConfig]="{ dateInputFormat: 'MMM YYYY', minMode: 'month', showWeekNumbers: false }"
                  [maxDate]="maxDateForPicker" />
                <div *ngIf="
                                                  invoice['invoiceMonth'].touched && invoice['invoiceMonth'].invalid
                                                " class="help-block text-danger">
                  <div *ngIf="
                                                    invoice['invoiceMonth'].errors &&
                                                    invoice['invoiceMonth'].errors['required']
                                                  ">
                    Please select invoice month
                  </div>


                </div>


              </div>
              <div class="form-group col-3">
                <label for="filterReportType">Payment Method<span style="color: red">*</span></label>
                <select id="filterReportType" class="form-control" placeholder="Select" formControlName="paymentMethod"
                  (change)="onPaymentTypeChange($event)">
                  <option value="" label="" disabled selected>Select</option>
                  <option *ngFor="let item of invoiceMethods" [value]="item.value">
                    {{ item.name }}
                  </option>
                </select>
                <div *ngIf="
                                                    invoice['paymentMethod'].touched && invoice['paymentMethod'].invalid
                                                  " class="help-block text-danger">
                  <div *ngIf="
                                                      invoice['paymentMethod'].errors &&
                                                      invoice['paymentMethod'].errors['required']
                                                    ">
                    Please select payment method
                  </div>


                </div>
              </div>
              <div class="form-group col-3">
                <label for="filterReportType">Status<span style="color: red">*</span></label>
                <select id="filterReportType" class="form-control" formControlName="invoiceStatus">
                  <option value="" disabled selected>Select</option>
                  <option *ngFor="let item of InvoiceStatus" [value]="item.value">
                    {{ item.name }}
                  </option>
                </select>
                <div *ngIf="
                                                      invoice['invoiceStatus'].touched && invoice['invoiceStatus'].invalid
                                                    " class="help-block text-danger">
                  <div *ngIf="
                                                        invoice['invoiceStatus'].errors &&
                                                        invoice['invoiceStatus'].errors['required']
                                                      ">
                    Please select invoice status
                  </div>


                </div>
              </div>
              <div class="form-group col-3">
                <label for="filterReportType">Customer Type</label>
                <select id="filterReportType" class="form-control" placeholder="Select" formControlName="customerType"
                  (change)="onCustomerTypeChange($event)">
                  <option value="" label="" disabled selected>Select</option>
                  <option *ngFor="let item of customerType" [value]="item.value">
                    {{ item.name }}
                  </option>
                </select>
                <div *ngIf="invoice['customerType'].touched && invoice['customerType'].invalid
                                                                                          "
                  class="help-block text-danger">
                  <div *ngIf="invoice['customerType'].errors &&
                                                                                              invoice['customerType'].errors['required']
                                                                                            ">
                    Please select customer type
                  </div>


                </div>
              </div>



            </div>
            <div class="input-wrapper row">
              <div class="form-group col-3">
                <label for="filterReportType">Mail to Customers<span style="color: red">*</span></label>
                <select id="filterReportType" class="form-control" placeholder="Select"
                  formControlName="mailToCustomer">
                  <option value="" label="" disabled selected>Select</option>
                  <option value="true" label="">Yes</option>
                  <option value="false" label="">No</option>

                </select>
                <div *ngIf="
                                                                        invoice['mailToCustomer'].touched && invoice['mailToCustomer'].invalid
                                                                      " class="help-block text-danger">
                  <div *ngIf="
                                                                          invoice['mailToCustomer'].errors &&
                                                                          invoice['mailToCustomer'].errors['required']
                                                                        ">
                    Please select customer mail configuration
                  </div>


                </div>
              </div>


            </div>

            <div class="input-wrapper row" *ngIf="generateInvoiceform.valid">
              <div class="form-group col-4">
                <label for="filterReportType">Generate Customers</label>
                <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings2"
                  [data]="finalCustomerRes" formControlName="generateCustomers"
                  (onSelect)="onItemSelectGenerate($event)" (onSelectAll)="onSelectAllGenerate($event)"
                  (onDeSelect)="onDeselectbrokerGenerate($event)" (onDeSelectAll)="onDeselectbrokerAllGenerate()">
                </ng-multiselect-dropdown>

              </div>
              <div class="form-group col-4">
                <label for="filterReportType">Skip Customers</label>

                <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings2"
                  [data]="finalCustomerRes" formControlName="skipCustomers"
                  (onSelect)="onItemSelectSkipGenerate($event)" (onSelectAll)="onSelectAllSkipGenerate($event)"
                  (onDeSelect)="onDeselectbrokerSkipGenerate($event)"
                  (onDeSelectAll)="onDeselectbrokerAllSkipGenerate()">
                </ng-multiselect-dropdown>
              </div>
              <div class="form-group col-4">
                <label for="filterReportType">Skip Mail Customers</label>

                <ng-multiselect-dropdown [placeholder]="'Select'" [settings]="dropdownSettings2"
                  [data]="finalCustomerRes" formControlName="skipMailCustomers"
                  (onSelect)="onItemSelectSkipMail($event)" (onSelectAll)="onSelectAllSkipMail($event)"
                  (onDeSelect)="onDeselectbrokerSkipMail($event)" (onDeSelectAll)="onDeselectbrokerAllSkipMail()">
                </ng-multiselect-dropdown>
              </div>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="generateinvoice()"
          [disabled]="generateInvoiceform.invalid">
          Generate
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Refund Confirmation Modal -->


<!-- Cancel Confirmation Modal -->
<div class="modal fade" data-bs-backdrop="static" id="refundcancel-model" tabindex="-1">
  <div class="modal-dialog modal-sm modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title">Refund</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
      </div>
      <div class="modal-body">

        <form [formGroup]="refundCancelInvoiceForm">
          <div class="container">
            <div class="row">
              <div class="form-group">
                <span class="admintitle">
                  Do you want cancel this invoice before refund&nbsp;&nbsp;<i class="bi bi-info-circle"></i>
                </span>

                <div class="form-check ps-0 d-flex">
                  <input class="" type="radio" id="refundStatusyes" name="refundStatus" formControlName="refundStatus"
                    value="true" />
                  <label class="form-check-label ps-1 my-auto" for="flexRadioDefault1">
                    Yes
                  </label>
                </div>
                <div class="form-check ps-0 d-flex">
                  <input class="" type="radio" id="refunStatusno" name="refundStatus" formControlName="refundStatus"
                    value="false" />
                  <label class="form-check-label ps-1 my-auto" for="flexRadioDefault2">
                    NO
                  </label>
                </div>


              </div>
            </div>

          </div>



        </form>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          Close
        </button>
        <button type="button" class="btn btn-primary" (click)="refundCancelinvoiceAmount()"
          [disabled]="refundCancelInvoiceForm.invalid">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Delete Confirmation Modal -->
 <div class="modal fade" data-bs-backdrop="static" id="deleteConfirmationModal" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="deleteConfirmationLabel">Delete</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <!-- <p>Type <strong>"DELETE"</strong> to confirm.</p> -->
        <form [formGroup]="deleteForm">
          <div class="mb-3">
            <label>Reference</label>
            <textarea type="text" class="form-control" appCapitalize formControlName="confirmationText" rows="3"
              placeholder="Enter the reference"></textarea>
          </div>
        </form>

        <!-- <div *ngIf="deleteForm['confirmationText'].touched && deleteForm['confirmationText'].invalid" class="help-block text-danger">
          <div *ngIf="deleteForm['confirmationText'].errors && deleteForm['confirmationText'].errors['required']">
            Please enter the reference</div>
        </div> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!deleteForm.valid" (click)="confirmDeletion()">
          Delete
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Invoice Status Change in Main Model list -->
<div class="modal fade" data-bs-backdrop="static" id="invoiceStatusConfirmationModal" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="invoiceStatusConfirmationModal">Info</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true" data-bs-dismiss="modal"
            (click)="CancelInvoieStatus()"></i>
        </div>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <!-- <p>Type <strong>"DELETE"</strong> to confirm.</p> -->
        <p>{{InvoiceChangeMessage}}</p>
        <form [formGroup]="invoiceStatusForm">
          <div class="mb-3">
            <label>Reference</label>
            <textarea type="text" class="form-control" appCapitalize formControlName="confirmationText" rows="3"
              placeholder="Enter the reference"></textarea>
          </div>
        </form>

        <!-- <div *ngIf="deleteForm['confirmationText'].touched && deleteForm['confirmationText'].invalid" class="help-block text-danger">
          <div *ngIf="deleteForm['confirmationText'].errors && deleteForm['confirmationText'].errors['required']">
            Please enter the reference</div>
        </div> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" (click)="CancelInvoieStatus()">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!invoiceStatusForm.valid"
          (click)="confirmInvoiceStatus()">
          Proceed
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Regenerate Confirmation Modal -->
<div class="modal fade" data-bs-backdrop="static" id="regenerateConfirmationModal" tabindex="-1">
  <div class="modal-dialog modal-md modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title" id="deleteConfirmationLabel">ReGenerate</h6>
        <div class="col-1 text-end ms-2 ms-md-2">
          <i style="margin-right: 4px" class="bi bi-x-circle" role="button" aria-hidden="true"
            data-bs-dismiss="modal"></i>
        </div>
        <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
      </div>
      <div class="modal-body">
        <!-- <p>Type <strong>"DELETE"</strong> to confirm.</p> -->
        <form [formGroup]="regenerateForm">
          <div class="mb-3">
            <label>Reference</label>
            <textarea type="text" class="form-control" appCapitalize formControlName="confirmationText" rows="3"
              placeholder="Enter the reference"></textarea>
          </div>
        </form>

        <!-- <div *ngIf="deleteForm['confirmationText'].touched && deleteForm['confirmationText'].invalid" class="help-block text-danger">
          <div *ngIf="deleteForm['confirmationText'].errors && deleteForm['confirmationText'].errors['required']">
            Please enter the reference</div>
        </div> -->
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
          Cancel
        </button>
        <button type="button" class="btn btn-primary" [disabled]="!regenerateForm.valid" (click)="confirmRegenerate()">
          Re-Generate
        </button>
      </div>
    </div>
  </div>
</div>


